import React from "react";

export const Home = ({ isWhite = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      className="nav-svg"
    >
      <path
        d="M21 19.9997C21 20.552 20.5523 20.9997 20 20.9997H4C3.44772 20.9997 3 20.552 3 19.9997V9.48882C3 9.18023 3.14247 8.88893 3.38606 8.69947L11.3861 2.47725C11.7472 2.19639 12.2528 2.19639 12.6139 2.47725L20.6139 8.69947C20.8575 8.88893 21 9.18023 21 9.48882V19.9997ZM19 18.9997V9.97791L12 4.53346L5 9.97791V18.9997H19Z"
        fill={isWhite ? "rgba(255, 255, 255, 1)" : "rgba(177,177,177,1)"}
      ></path>
    </svg>
  );
};

export const Blog = ({ isWhite = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      className="nav-svg"
    >
      <path
        d="M6.93912 14.0327C6.7072 14.6562 6.51032 15.233 6.33421 15.8154C7.29345 15.1188 8.43544 14.6766 9.75193 14.512C12.2652 14.1979 14.4976 12.5384 15.6279 10.4535L14.1721 8.99878L15.5848 7.58407C15.9185 7.24993 16.2521 6.91603 16.5858 6.58237C17.0151 6.15301 17.5 5.35838 18.0129 4.21479C12.4197 5.08172 8.99484 8.50636 6.93912 14.0327ZM17 8.99728L18 9.99658C17 12.9966 14 15.9966 10 16.4966C7.33146 16.8301 5.66421 18.6635 4.99824 21.9966H3C4 15.9966 6 1.99658 21 1.99658C20.0009 4.99392 19.0018 6.99303 18.0027 7.99391C17.6662 8.33038 17.3331 8.66372 17 8.99728Z"
        fill={isWhite ? "rgba(255, 255, 255, 1)" : "rgba(177,177,177,1)"}
      ></path>
    </svg>
  );
};

export const ThreeD = ({ isWhite = false, isButton = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      style={{
        paddingRight: "1px",
        transition: "transform 0.3s ease-in-out",
        transform: isWhite && isButton ? "rotate(120deg)" : "none",
      }}
      className="nav-svg threeD-logo"
    >
      <path
        d="M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L12.0001 10.8444L18.5062 7.07774L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329ZM13.0001 20.11L19.5 16.3469V8.81337L13.0001 12.5765V20.11Z"
        fill={isWhite ? "rgba(255, 255, 255, 1)" : "rgba(177,177,177,1)"}
      ></path>
    </svg>
  );
};

export const Insomniac = ({ isWhite = false }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 919 922"
      fill="none"
      style={{ paddingRight: "2px" }}
      xmlns="http://www.w3.org/2000/svg"
      className="nav-svg"
    >
      <path
        d="M715.862 539.862L710.351 588.12C706.5 607.5 704.719 613.77 695.5 635.5L684 658.5L670.5 681.5C625 756.882 565.886 817.179 486.306 856.756L472.651 863.546L395.909 892.727C380.154 898.717 384.139 920.451 401.136 921.236L402.266 921.288C449.04 923.449 495.926 920.685 542.033 913.049L556.762 910.609C576.363 907.363 595.688 902.807 614.585 896.975L618.39 895.801C660.319 882.863 699.59 863.405 734.539 838.254C766.475 815.269 794.398 787.82 817.315 756.882L822.911 749.326C839.758 726.583 854.172 702.357 865.946 676.996L888.619 628.159C890.539 624.023 892.205 619.794 893.61 615.492C897.174 604.579 899.441 593.265 902.92 582.324C908.044 566.215 911.429 549.605 913.019 532.776L916.488 496.062C919.487 464.319 918.989 432.342 915.004 400.708C912.091 377.581 907.325 354.726 900.752 332.362L898.045 323.151C896.384 313.029 892.983 303.24 888.619 293.841L865.946 245.004C854.172 219.643 839.758 195.418 822.911 172.674L817.315 165.118C794.398 134.18 766.475 106.731 734.539 83.7464C699.59 58.595 660.319 39.1373 618.39 26.199L614.585 25.0249C595.688 19.1935 576.363 14.6369 556.762 11.3906L542.033 8.95117C495.926 1.31483 449.04 -1.44922 402.266 0.711624L401.136 0.763835C384.139 1.54903 380.154 23.2827 395.909 29.2731L472.651 58.4537L486.306 65.2444C565.886 104.821 630.428 166.276 671.139 241.238L688.984 285.145C695.536 303.443 699.903 319.708 704.816 336.482L707.374 352.619C717.184 414.521 720.031 477.327 715.862 539.862Z"
        fill={isWhite ? "rgba(141,178,187,1)" : "rgba(177,177,177,1)"}
      />
      <path
        d="M87.5004 252.929L98.1598 242.606C124.097 217.487 155.596 198.842 190.096 188.189L200.658 184.927C219.777 179.023 239.796 176.581 259.774 177.715L279.802 178.852C284.036 179.092 288.206 179.993 292.161 181.523L303.1 185.753C328.224 195.469 332.768 229.071 311.128 245.112L273.001 271.57C261.388 279.629 250.568 288.774 240.687 298.882C208.119 332.2 186.812 374.886 179.761 420.941L179.43 423.1C174.469 455.503 176.503 488.594 185.394 520.147L187.514 527.672C200.42 573.472 225.386 614.967 259.804 647.824L264.442 652.252C277.512 664.729 291.988 675.645 307.579 684.781L327.975 696.732C329.208 697.454 330.357 698.31 331.403 699.285C342.527 709.654 337.977 728.206 323.318 732.251L321.41 732.778C320.444 733.044 319.46 733.24 318.466 733.363L302.128 735.385C288.067 737.125 273.882 737.644 259.732 736.937L257.847 736.843C196.538 733.779 137.664 709.259 92.0203 668.213C53.863 633.899 25.8429 589.077 11.9939 539.664L10.8573 535.608C-4.05889 482.388 -3.12094 425.777 13.4382 373.045C27.7327 327.524 53.2263 286.122 87.5004 252.929Z"
        fill={isWhite ? "rgba(141,178,187,1)" : "rgba(177,177,177,1)"}
      />
    </svg>
  );
};
